import React, { Component } from "react";
import { Container, Row, Col, Form } from "react-bootstrap"
import { TableCell, TableRow } from "@mui/material";
import CreatableSelect from 'react-select/creatable';
import axios from "axios";
import PhoneClinicGrid from "../../Components/PhoneClinicGrid";
import RowActions from "../../Components/PhoneClinicGrid/RowActions";
import { pcSelectStyles, pcSelectTheme } from "../../Components/PCSelect";
import FormCard from './shared/FormCard';

class CommonDevices extends Component {
    constructor(props) {
        super(props);
        this.state = {

            DeviceList: [],
            addDevice: false,
            deviceTypeList: [
                { value: 'Phone', label: 'Phone' },
                { value: 'Tablet', label: 'Tablet' },
                { value: 'Laptop', label: 'Laptop' },
                { value: 'Gaming Console', label: 'Gaming Console' },
                { value: 'Watch', label: 'Watch' },
            ],
            DEVICE_ID: "",
            DEVICE_TYPE: "",
            DEVICE_BRAND: "",
            DEVICE_NAME: ""
        };
        this.gridRef = React.createRef(null);
    }

    // componentDidMount() {
    //     let { searchGridData, totalRecordsPerPage, paginationValue } = this.state
    //     this.getDeviceList(searchGridData, totalRecordsPerPage.value, paginationValue)
    // }

    async getDeviceList(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true);
        let formData = {
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset
        };
        const getDevice = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetDevice.php`, formData);
        let deviceData = getDevice.data
        let DeviceList = []
        if (deviceData.success === 1) {
            DeviceList = deviceData.data
            pagination.totalItems = parseInt(deviceData.Page_count[0]['TOTAL_PAGE_COUNT'])
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)
            this.gridRef.current?.setPaginationData(pagination)
        }
        this.setState({ DeviceList })
        this.props.toggleLoader(false)
    }

    handleAddDevice() {
        this.setState({ addDevice: true })
    }

    handleChangeInput(fieldName, event) {
        let targetValue
        switch (fieldName) {
            case "DEVICE_TYPE":
                targetValue = event
                break;

            default:
                targetValue = event.target.value
                break;
        }
        this.setState({ [fieldName]: targetValue })
    }

    handleCancelDevice() {
        this.setState({
            DEVICE_ID: "",
            addDevice: false,
            DEVICE_TYPE: "",
            DEVICE_BRAND: "",
            DEVICE_NAME: ""
        })
    }

    async handleSubmitDevice() {
        this.props.toggleLoader(true)
        let formData = {
            DEVICE_ID: this.state.DEVICE_ID,
            DEVICE_TYPE: this.state.DEVICE_TYPE?.value,
            DEVICE_BRAND: this.state.DEVICE_BRAND,
            DEVICE_NAME: this.state.DEVICE_NAME
        }
        await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/PCAddDevice.php`, formData);
        this.handleCancelDevice()
        this.getDeviceList()
    }


    handleEdit(indx) {
        let { DeviceList } = this.state
        this.setState({
            DEVICE_ID: DeviceList[indx]['DEVICE_ID'],
            DEVICE_TYPE: { label: DeviceList[indx]['DEVICE_TYPE'], value: DeviceList[indx]['DEVICE_TYPE'] },
            DEVICE_BRAND: DeviceList[indx]['DEVICE_BRAND'],
            DEVICE_NAME: DeviceList[indx]['DEVICE_NAME'],
            addDevice: true
        })
    }

    render() {
        return (
            <Container>
                {this.state.addDevice === false ?
                    <PhoneClinicGrid
                        title="DEVICE"
                        buttonLabel="Add Device"
                        onClickButton={this.handleAddDevice.bind(this)}
                        isEditable={true}
                        ref={this.gridRef}
                        getData={this.getDeviceList.bind(this)}
                        tableHeadData={[
                            { label: "TYPE", isHidden: false },
                            { label: "BRAND", isHidden: false },
                            { label: "DEVICE", isHidden: false },
                        ]}
                    >
                        {this.state.DeviceList.map((device, idx) => (
                            <TableRow
                                key={idx}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                style={{ whiteSpace: 'nowrap' }}
                            >
                                <TableCell>{device.DEVICE_TYPE}</TableCell>
                                <TableCell>{device.DEVICE_BRAND}</TableCell>
                                <TableCell>{device.DEVICE_NAME}</TableCell>
                                <TableCell align='center'>
                                    <RowActions actions={[
                                        { type: 'edit', onClick: this.handleEdit.bind(this, idx) },
                                    ]} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </PhoneClinicGrid>
                    :
                    <>
                        <FormCard title={this.state.DEVICE_ID ? 'Edit Device' : 'Add Device'} mode={this.state.DEVICE_ID ? 'edit' : 'new'}
                            onCancel={this.handleCancelDevice.bind(this)}
                            onSave={this.handleSubmitDevice.bind(this)} saveLabel="Save">
                        <Row>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Device</Form.Label>
                                    <CreatableSelect
                                        name={"DEVICE_TYPE"}
                                        styles={pcSelectStyles}
                                        theme={pcSelectTheme}
                                        menuPortalTarget={document.body}
                                        options={this.state.deviceTypeList}
                                        onChange={this.handleChangeInput.bind(this, "DEVICE_TYPE")}
                                        value={this.state.DEVICE_TYPE}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Brand</Form.Label>
                                    <Form.Control
                                        value={this.state.DEVICE_BRAND}
                                        name={"DEVICE_BRAND"}
                                        onChange={this.handleChangeInput.bind(this, "DEVICE_BRAND")}
                                       
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Model</Form.Label>
                                    <Form.Control
                                        value={this.state.DEVICE_NAME}
                                        name={"DEVICE_NAME"}
                                        onChange={this.handleChangeInput.bind(this, "DEVICE_NAME")}
                                        style={{ width: "100%" }}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        </FormCard>
                    </>
                }
            </Container>
        );
    }
}

export default CommonDevices;